import { Sparkles } from "lucide-react";
import "./Hero.css";

const PULSE_DOTS: [number, number][] = [
  [60, 130],
  [180, 90],
  [280, 60],
  [240, 145],
];

export const Hero = () => {
  return (
    <section className="gg-hero">
      <div className="gg-hero-text">
        <h1 className="gg-hero-title">
          Bem vindo ao GG <span className="gg-hero-title-accent">Hub</span>
        </h1>
        <p className="gg-hero-sub">
          Seu portal interno para análise de admissões, dúvidas e respostas, e
          gestão da rotina dos times Onfly.
        </p>
      </div>
      <div className="gg-hero-art" aria-hidden>
        <svg viewBox="0 0 320 200" preserveAspectRatio="xMidYMid slice">
          <defs>
            <linearGradient id="rh" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#009EFB" stopOpacity="0.18" />
              <stop offset="100%" stopColor="#009EFB" stopOpacity="0" />
            </linearGradient>
            <path id="hero-route-1" d="M -20 150 Q 80 40 180 90 T 340 50" />
            <path id="hero-route-2" d="M -20 80 Q 100 180 200 130 T 340 160" />
          </defs>
          <rect width="320" height="200" fill="url(#rh)" />
          <path d="M -20 150 Q 80 40 180 90 T 340 50" stroke="#009EFB" strokeWidth="1" strokeDasharray="3 6" fill="none" opacity="0.6" />
          <path d="M -20 80 Q 100 180 200 130 T 340 160" stroke="#009EFB" strokeWidth="1" strokeDasharray="3 6" fill="none" opacity="0.6" />
          <circle r="4" fill="#009EFB">
            <animateMotion dur="9s" repeatCount="indefinite"><mpath href="#hero-route-1" /></animateMotion>
          </circle>
          <circle r="4" fill="#0062AB">
            <animateMotion dur="11s" repeatCount="indefinite" begin="2s"><mpath href="#hero-route-2" /></animateMotion>
          </circle>
          {PULSE_DOTS.map(([x, y], i) => (
            <g key={i}>
              <circle cx={x} cy={y} r="3" fill="#009EFB" />
              <circle cx={x} cy={y} r="3" fill="none" stroke="#009EFB" strokeWidth="1" opacity="0.4">
                <animate attributeName="r" from="3" to="14" dur="2.4s" begin={`${i * 0.5}s`} repeatCount="indefinite" />
                <animate attributeName="opacity" from="0.5" to="0" dur="2.4s" begin={`${i * 0.5}s`} repeatCount="indefinite" />
              </circle>
            </g>
          ))}
        </svg>
      </div>
    </section>
  );
};
